<template>
<div>
    
    <div style="margin-top: 15px;">
    <b>Call Handling</b>
    </div>

    <v-select
        label="When a call is received"
        :items="modes"
        :value="profile.employee_account.voice_settings.voice_mode"
        v-on:change="onUpdateVoiceMode"
        style="margin-top: 15px;"
        :hint="smart_call_received_hint"
        persistent-hint
    />

    <v-text-field
        label="Forward incoming phone calls to"
        :value="pretty_print_forward_calls_to"
        disabled
        v-if="profile.employee_account.voice_settings.voice_mode == 'forward-to-one-number'"
        autocomplete="off"
    >

        <v-icon 
            slot="append-outer" 
            v-on:click="onEditForwardCallsTo"
            color="primary"
            style="pointer-events: auto;"
            v-show="can_write"
        >
            mdi-lead-pencil
        </v-icon>

    </v-text-field>

    <v-select
        label="When forwarding a call, what caller id would you like to come up on your phone"
        :items="caller_id_modes"
        :value="profile.employee_account.voice_settings.inbound_caller_id_mode"
        v-on:change="onUpdateCallerIdMode"
        style="margin-top: 15px;"
    />

     <v-select
        label="When the phone is answered"
        :items="pickup_options"
        :value="profile.employee_account.voice_settings.use_digit_press_voicemail_detection"
        v-on:change="onUpdateVoicemailDetection"
        style="margin-top: 15px;"
        v-if="profile.employee_account.voice_settings.voice_mode == 'forward-to-one-number'"
    
    />

    <m-edit-forward-incoming-calls-dialog
        ref="edit_dialog"
        v-on:ok="onUpdateForward"
    />

    <div style="margin-top: 15px;">
    <b>Voicemail</b>
    </div>

    <v-switch
        label="Voicemail Enabled"
        :input-value="profile.voicemail_settings.enabled"
        v-on:change="onClickVoicemailEnable"
    >
    </v-switch>

    <m-edit-text
        label="Voicemail answer delay (in seconds)"
        :value="profile.voicemail_settings.voicemail_delay_in_seconds"
        v-on:input="onEditVoicemailDelay($event)"
        integer_positive_non_zero
    />
   
    <b>Voicemail Greeting</b><br/><br/>
    <audio controls :src="url_greeting" type="audio/ogg">
        Your browser does not support the audio element.
    </audio>

    <div style="text-align: left; margin-top: 15px; margin-bottom: 15px;">
        <v-btn
            v-on:click="onClickUseDefaultGreeting"
        >
            Use default greeting...
        </v-btn>

        <v-btn
            color="primary"
            style="margin-left: 15px;"
            v-on:click="onClickUploadGreeting"
        >
            Upload new greeting...
        </v-btn>
    </div>

    Looking for an easy way to record an mp3 file? Check out <a href="https://online-voice-recorder.com/" target="_blank">this voice recording tool</a>

    <m-edit-blobs-dialog
        ref="attach-greeting-dialog"
        title="Upload Greeting"
        v-on:ok="afterUploadGreeting($event)"
        :externally_visible="true"
    />

</div>
</template>

<script>
var _ = require('lodash');
const E164 = require('@/js/E164.js');

export default {
    props: {
        profile: {
            type: Object,
            default: function() { return {}; }
        },
    },

    data() {
        return {
            modes: [
                {'text': 'Play a message asking the caller to text instead', value: 'not-supported'},
                {'text': 'Send the caller directly to voicemail', value: 'voicemail-only'},
                {'text': 'Forward the phone call to one number', value: 'forward-to-one-number'}
            ],

            caller_id_modes: [
                {'text' : 'Show all forwarded calls as coming from my RedChirp number', value: 'patch-call-from-red-chirp-number' },
                {'text' : 'Show all forwarded calls as coming from the caller\'s number', value: 'patch-call-from-callers-number' }
            ],

            pickup_options: [
                {'text': 'Connect the caller immediately', value: false },
                {'text': 'Require that a digit be pressed before the call is connected', value: true },
            ],
        }
    },

    methods: {
        onEditForwardCallsTo()
        {
            this.$refs['edit_dialog'].showDialog(this.profile);
        },

        onUpdateForward(voice_settings_from_dialog)
        {
            let voice_settings = _.cloneDeep(this.profile.employee_account.voice_settings);
            voice_settings.forward_incoming_calls = voice_settings_from_dialog.forward_incoming_calls;

            let changes = {
                'voice_settings' : voice_settings,
            };

            this.$emit('patch-employee-account',changes);
        },

        onUpdateVoiceMode(mode)
        {
            let voice_settings = _.cloneDeep(this.profile.employee_account.voice_settings);
            voice_settings.voice_mode = mode;

            let changes = {
                'voice_settings' : voice_settings,
            };

            this.$emit('patch-employee-account',changes);
        },

        onUpdateCallerIdMode(mode)
        {
            let voice_settings = _.cloneDeep(this.profile.employee_account.voice_settings);
            voice_settings.inbound_caller_id_mode = mode;

            let changes = {
                'voice_settings' : voice_settings,
            };

            this.$emit('patch-employee-account',changes);
        },

        onUpdateVoicemailDetection(use_digit_press)
        {
            let voice_settings = _.cloneDeep(this.profile.employee_account.voice_settings);
            voice_settings.use_digit_press_voicemail_detection = use_digit_press;

            let changes = {
                'voice_settings' : voice_settings,
            };

            this.$emit('patch-employee-account',changes);
        },

        onClickVoicemailEnable()
        {
            let new_settings = _.cloneDeep(this.profile.voicemail_settings);
            new_settings.enabled = !new_settings.enabled;

            this.upsertVoicemailSettings(new_settings);
        },

        onEditVoicemailDelay(new_delay)
        {
            if ( new_delay < 5 )
            {
                alert('Delay must be at least 5 seconds');
                return;
            }

            let new_settings = _.cloneDeep(this.profile.voicemail_settings);
            new_settings.voicemail_delay_in_seconds = new_delay;

            this.upsertVoicemailSettings(new_settings);
        },

        upsertVoicemailSettings(settings)
        {
            this.$rc.showSpinner();
            
            this.$rc.upsertVoicemailSettings(
                settings,
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.$emit('reload-profile');
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to update voicemail settings');
                },
            );
        },

        onClickUseDefaultGreeting()
        {
            this.$rc.confirm(
                'Use default greeting',
                'Use the default (generic) voicemail greeting?  This will remove any custom greeting you may have recorded.',
                [
                    {'text': 'Cancel', 'value': 'cancel'},
                    {'text': 'Yes, use default greeting', 'value': 'confirm'},
                ],

                (response) => {
                    if (response == 'confirm') 
                    {
                        let new_settings = _.cloneDeep(this.profile.voicemail_settings);
                        new_settings.url_greeting = 'https://files.redchirp.com/default-voicemail-greeting.mp3';
                        this.upsertVoicemailSettings(new_settings);
                    } 
                    else 
                    {
                        return;
                    }
                }

            );
        },

        onClickUploadGreeting()
        {
            this.$refs['attach-greeting-dialog'].showDialog();
        },

        afterUploadGreeting(blobs)
        {
            if ( blobs.length != 1 )
                alert('You must upload only one greeting');

            this.$rc.showSpinner();
            
            this.$rc.getBlobMetaDataMultiple(
                blobs,
            
                (data) => {
                    this.$rc.hideSpinner();

                    let meta_data = data.meta_data[0];

                    if ( meta_data.content_type != 'audio/mpeg' )
                    {
                        alert('You must upload a mp3 file');
                        return;
                    }


                    let new_settings = _.cloneDeep(this.profile.voicemail_settings);
                    new_settings.url_greeting = 'https://files.redchirp.com/'+meta_data.object_name;
                    this.upsertVoicemailSettings(new_settings);

                    alert('Greeting changed');
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get voice greeting meta data');
                },
            );
        }
    },

    computed: {
        can_write() {
            return this.profile.actor_permissions.can_write; 
        },

        pretty_print_forward_calls_to()
        {
            let endpoint = this.profile.employee_account.voice_settings.forward_incoming_calls; 

            if ( endpoint == null )
                return "Do not forward incoming calls";

            return E164.prettyPrintUsPhoneNumber(endpoint);
        },

        url_greeting()
        {
            return this.profile.voicemail_settings.url_greeting;
        },

        smart_call_received_hint()
        {
            if ( this.profile.voicemail_settings.enabled == false )
            {
                return 'Because you have disabled voicemail, a message will be played asking the caller to text';
            }

            return '';
        },

    
        
    },
}
</script>

<style lang="scss" scoped>

</style>